import type { SVGProps } from 'react';

interface PlayerAvatarIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const PlayerAvatarIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & PlayerAvatarIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 22 15"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="m15.504 10.491 6.082 3.959H.2l6.076-3.959s-2.93-1.804-2.145-3.586C4.662 5.697 7.586 2.562 9.414.678a2.049 2.049 0 0 1 2.953 0c1.827 1.862 4.751 5.019 5.283 6.227.764 1.782-2.146 3.586-2.146 3.586"
      fill="#D0DCEE"
    />
  </svg>
);
